import React, { FC } from "react";
import { Helmet } from "react-helmet";
import { Card } from "semantic-ui-react";
import SariaImage from "./components/atoms/Image";

export interface Props {
  xid: string;
  emotion: string;
  image_url: string;
  created_at: string;
}

const PictureCard: FC<Props> = ({
  xid = "",
  emotion = "",
  image_url = "",
  created_at = "",
}) => (
  <>
    <Helmet>
      <title>幸せ度チェッカー</title>
    </Helmet>
    <Card href={`/photos/${xid}`}>
      <SariaImage path={image_url}></SariaImage>
      <Card.Content>
        <Card.Header>{emotion} pt.</Card.Header>
        <Card.Meta>
          <span className="date">Posted at {created_at}</span>
        </Card.Meta>
      </Card.Content>
    </Card>
  </>
);

export default PictureCard;
